let lockCount = 0

export function lockModalBodyScroll(): void {
  lockCount += 1
  document.body.style.overflow = 'hidden'
}

export function unlockModalBodyScroll(): void {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) {
    document.body.style.overflow = ''
  }
}

/** Reset scroll lock after route changes or when all modal owners unmount. */
export function resetModalBodyScrollLock(): void {
  lockCount = 0
  document.body.style.overflow = ''
}

export function getModalBodyScrollLockCount(): number {
  return lockCount
}
